import React from "react";
import { Module } from "../../components/common";
import {
  HomePage,
  CondicoesGerais,
  Typografy,
  Acoes,
  OutrosComponentes,
} from "./pages";

const Catalogo = () => {
  return (
    <Module moduleName="Catálogo">
      <Module.Page
        path="/tipografia"
        page={Typografy}
        title="Tipografia"
        description="Exemplos dos elementos de tipografia como Títulos, textos e links"
      />
      <Module.Page
        path="/acoes/tipografia"
        page={Typografy}
        title="Tipografia"
        description="Exemplos dos elementos de tipografia como Títulos, textos e links"
        disableNavigation
        parentPage="/acoes"
        exact
      />
      <Module.Page
        path="/acoes"
        page={Acoes}
        title="Ações"
        description="Exemplos de componentes de ações (links e botões)"
      />
      <Module.Page
        path="/outros-componentes"
        page={OutrosComponentes}
        title="Outros Componentes"
        description="Modais, loading, Switch Content, List, Search List"
      />
      <Module.Page
        path="/sub-pagina2"
        page={CondicoesGerais}
        title="Sub página 2"
        description="Descrição da segunda página de exemplo"
      />
      <Module.Page
        path="/sub-pagina3"
        page={CondicoesGerais}
        title="Sub página 3"
        description="Descrição da segunda página de exemplo"
      />
      <Module.Page
        path="/sub-pagina4"
        page={CondicoesGerais}
        title="Sub página 4"
        description="Descrição da segunda página de exemplo 4"
      />
      <Module.Page
        path="/sub-pagina5"
        page={CondicoesGerais}
        title="Sub página 5"
        description="Descrição da segunda página de exemplo 5"
        parentPage="/sub-pagina4"
        disableNavigation
      />
      <Module.Page path="/" page={HomePage} title="Página Inicial" />
    </Module>
  );
};

Catalogo.propTypes = {};

export default Catalogo;
